"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeframeGranularity = void 0;
var TimeframeGranularity;
(function (TimeframeGranularity) {
    TimeframeGranularity["MIN"] = "min";
    TimeframeGranularity["FIVE_MINS"] = "fiveMin";
    TimeframeGranularity["TEN_MINS"] = "tenMin";
    TimeframeGranularity["QUARTER_HOUR"] = "quarterHour";
    TimeframeGranularity["HALF_HOUR"] = "halfHour";
    TimeframeGranularity["HOUR"] = "hour";
    TimeframeGranularity["DAY"] = "day";
    TimeframeGranularity["WEEK"] = "week";
    TimeframeGranularity["MONTH"] = "month";
})(TimeframeGranularity = exports.TimeframeGranularity || (exports.TimeframeGranularity = {}));
